//deps
import styled from "styled-components";

//components
import { CartGroupContainer } from "@swiggy-private/cart-ui";

interface IStyles {
    isCollapsible?: boolean;
}

export const BillDetailCartGroupContainer = styled(CartGroupContainer)<IStyles>(({ theme, isCollapsible }) => ({
    position: "relative",
    padding: isCollapsible
        ? `${theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium} !important`
        : `${theme.spacing.small} ${theme.spacing.medium} ${theme.spacing.large} !important`,
    boxShadow: "none !important",
}));

export const BillDetailsBannerContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.large} calc(${theme.spacing.medium} * -1) calc(${theme.spacing.small} * -1) calc(${theme.spacing.medium} * -1)`,
}));
